import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _URL from "@babel/runtime-corejs3/core-js/url";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
import deepExtend from "deep-extend";
import identity from "lodash/identity";

const withHelpfulMissingBodyError = obj => {
  if (!Object.prototype.hasOwnProperty.call(obj, 'body')) {
    _Object$defineProperty(obj, 'body', {
      enumerable: false,
      get: () => {
        throw new Error(`Body of response is not automatically made available. You must either call 
  \`const body = await result.response.json()\` or \`const body = await error.response.json()\`

or call #readJsonBody or #readJsonErrorBody() on the request builder
`);
      }
    });
  }

  return obj;
};

const withHelpfulMissingResponseError = obj => {
  if (!Object.prototype.hasOwnProperty.call(obj, 'response') && !Object.prototype.hasOwnProperty.call(obj, 'body')) {
    _Object$defineProperty(obj, 'body', {
      enumerable: false,
      get: () => {
        throw new Error(`error.body is not available because no request was made. Check the network logs and console for more info`);
      }
    });
  }

  return withHelpfulMissingBodyError(obj);
};

const errorResponseHandler = result => {
  const {
    response
  } = result;

  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }

  return result;
};
/** a request builder based on fetch, useful in service workers  */


var _requestProperties = /*#__PURE__*/new _WeakMap();

var _responseMappers = /*#__PURE__*/new _WeakMap();

var _errorMappers = /*#__PURE__*/new _WeakMap();

var _mapResponse = /*#__PURE__*/new _WeakMap();

var _mapError = /*#__PURE__*/new _WeakMap();

var _extendCopy = /*#__PURE__*/new _WeakMap();

export default class FetchRequestBuilder {
  constructor() {
    _classPrivateFieldInitSpec(this, _requestProperties, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _responseMappers, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _errorMappers, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _mapResponse, {
      writable: true,
      value: response => {
        var _context;

        return withHelpfulMissingBodyError(_reduceInstanceProperty(_context = _classPrivateFieldGet(this, _responseMappers)).call(_context, async (last, mapper) => withHelpfulMissingBodyError(mapper(await last)), response));
      }
    });

    _classPrivateFieldInitSpec(this, _mapError, {
      writable: true,
      value: async error => {
        var _context2;

        throw withHelpfulMissingResponseError(await _reduceInstanceProperty(_context2 = _classPrivateFieldGet(this, _errorMappers)).call(_context2, async (last, mapper) => withHelpfulMissingResponseError(mapper(await last)), error));
      }
    });

    _classPrivateFieldInitSpec(this, _extendCopy, {
      writable: true,
      value: _ref => {
        let {
          query: queryB,
          headers: headersB,
          body: bodyB,
          responseMappers: responseMappersB = [],
          errorMappers: errorMappersB = [],
          mode: modeB,
          host: hostB,
          path: pathB = [],
          ...restB
        } = _ref;
        const copy = new FetchRequestBuilder();

        const {
          query: queryA,
          headers: headersA,
          body: bodyA,
          mode: modeA,
          host: hostA,
          path: pathA,
          ...restA
        } = _classPrivateFieldGet(this, _requestProperties);

        const responseMappersA = _classPrivateFieldGet(this, _responseMappers);

        const errorMappersA = _classPrivateFieldGet(this, _errorMappers);

        _classPrivateFieldSet(copy, _responseMappers, [...responseMappersA, ...responseMappersB]);

        _classPrivateFieldSet(copy, _errorMappers, [...errorMappersA, ...errorMappersB]);

        _classPrivateFieldSet(copy, _requestProperties, { ...restA,
          ...restB,
          mode: modeB || modeA,
          query: { ...queryA,
            ...queryB
          },
          headers: { ...headersA,
            ...headersB
          },
          body: bodyA || bodyB ? { ...bodyA,
            ...bodyB
          } : null,
          host: hostB || hostA,
          path: [...pathA, ...pathB]
        });

        return copy;
      }
    });

    _classPrivateFieldSet(this, _responseMappers, []);

    _classPrivateFieldSet(this, _errorMappers, []);

    _classPrivateFieldSet(this, _requestProperties, {
      url: null,
      method: null,
      credentials: null,
      mode: null,
      query: {},
      body: null,
      headers: {},
      host: null,
      path: []
    });
  }

  host(host) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      host
    });
  }

  path() {
    for (var _len = arguments.length, pathSegments = new Array(_len), _key = 0; _key < _len; _key++) {
      pathSegments[_key] = arguments[_key];
    }

    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      path: _mapInstanceProperty(pathSegments).call(pathSegments, segment => segment.replace(/^\/+/, '').replace(/\/+$/, '').replace(/\/{2,}/, '/'))
    });
  }

  get(url) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      url,
      method: 'GET'
    });
  }

  head(url) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      url,
      method: 'HEAD'
    });
  }

  post(url) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      url,
      method: 'POST'
    });
  }

  patch(url) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      url,
      method: 'PATCH'
    });
  }

  put(url) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      url,
      method: 'PUT'
    });
  }

  del(url) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      url,
      method: 'DELETE'
    });
  }

  query(query) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      query
    });
  }

  set(headerKey, headerValue) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      headers: {
        [headerKey]: headerValue
      }
    });
  }

  send(body) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      body
    });
  }

  withCredentials() {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      credentials: 'include'
    });
  }

  mode(mode) {
    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      mode
    });
  }

  mapResponse() {
    for (var _len2 = arguments.length, responseMappers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      responseMappers[_key2] = arguments[_key2];
    }

    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      responseMappers
    });
  }

  mapError() {
    for (var _len3 = arguments.length, errorMappers = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      errorMappers[_key3] = arguments[_key3];
    }

    return _classPrivateFieldGet(this, _extendCopy).call(this, {
      errorMappers
    });
  }

  readJsonErrorBody() {
    return this.mapError(async err => {
      const newError = new Error(err.message);
      newError.stack = err.stack;

      if (err.response) {
        newError.response = err.response;

        try {
          newError.body = await err.response.json();
        } catch (parseError) {
          newError.body = null;
          newError.message += `\n\nAdditionally. This happened while trying to parse response: ${parseError.message}`;
        }
      }

      return newError;
    });
  }

  readJsonBody() {
    return this.mapResponse(async _ref2 => {
      let {
        response
      } = _ref2;
      const body = await response.json();
      return {
        response,
        body
      };
    }).readJsonErrorBody();
  }

  then(resolveHandler, rejectHandler) {
    var _context3, _context4;

    const {
      url: urlString,
      method,
      body,
      headers,
      credentials,
      query,
      mode,
      host,
      path
    } = _classPrivateFieldGet(this, _requestProperties);

    const fullUrl = _filterInstanceProperty(_context3 = [...path, urlString]).call(_context3, identity).join('/');

    const url = new _URL(fullUrl, host === null ? undefined : host);

    _forEachInstanceProperty(_context4 = _Object$entries(query)).call(_context4, _ref3 => {
      let [key, value] = _ref3;
      url.searchParams.append(key, value);
    });

    const requestInit = {
      method,
      headers
    };

    if (method !== 'HEAD' && method !== 'GET' && body !== null) {
      /* Only supports json body */
      if (!headers['Content-Type']) {
        /* eslint-disable-next-line no-console */
        console.warn('Body of request was set without a content type. Builder assumes that the body should be serialized as JSON, however you should still include a `Content-Type`');
      }

      requestInit.body = _JSON$stringify(body);
    }

    if (mode) requestInit.mode = mode;
    if (credentials) requestInit.credentials = credentials;
    return _globalThis.fetch(url, requestInit) // Wrap response to have parity with error handling API where response is in nested key
    .then(response => ({
      response
    })).then(errorResponseHandler).then(_classPrivateFieldGet(this, _mapResponse)).catch(_classPrivateFieldGet(this, _mapError)).then(resolveHandler, rejectHandler);
  }

  catch(rejectHandler) {
    return this.then(null, rejectHandler);
  }

  toJSON() {
    return deepExtend({}, _classPrivateFieldGet(this, _requestProperties));
  }

}
export const request = new FetchRequestBuilder();